import Vue from 'vue';
import {
  ENGLISH_REVERSE_CONTINUOUS_TYPE,
  INSIDER_TYPE,
  MULTILOT_TYPE,
} from '@/constants/auction';
import { SCHEDULE_SPECIFIC } from '@/components/forms/auctionForm/auctionFormConstants';

export function mapAuctionItems(items) {
  return items.map((item) => {
    const mapped = {
      description: item.description,
      quantity: item.quantity,
    };
    if (item.unit && item.unit.name && item.unit.name.length) {
      mapped.unit = { name: item.unit.name };
    }
    if (item.documentUrl) {
      mapped.documentUrl = item.documentUrl;
    }
    if (item.relatedLot) {
      mapped.relatedLot = item.relatedLot;
    }
    return mapped;
  });
}

/** 32 lowercase hex chars — a valid MD5Type id, matching what the API expects for lot ids. */
export function generateLotId() {
  let hex = '';
  for (let i = 0; i < 32; i += 1) {
    hex += Math.floor(Math.random() * 16).toString(16);
  }
  return hex;
}

/**
 * Build the API-shaped `lots[]` array for a multilot auction. Every lot shares the
 * same pre-planned auctionPeriod (the same schedule picker used for other types).
 */
export function buildMultilotLots({ lots, currency, auctionPeriod }) {
  return lots.map((lot) => ({
    id: lot.id,
    title: lot.title,
    value: {
      amount: Number(lot.value),
      currency,
    },
    minimalStep: {
      amount: Number(lot.minimalStep),
      currency,
    },
    auctionPeriod: { ...auctionPeriod },
  }));
}

export function buildAuctionPeriod({
  typeAuction,
  hasSpecificStart,
  auctionStartDateIso,
  auctionStartTime,
  startScheduleValue,
  endScheduleValue,
  auctionEndDateIso,
  auctionEndTime,
}) {
  const now = new Date();
  const startDate = hasSpecificStart
    ? `${auctionStartDateIso}T${auctionStartTime}:00`
    : Vue.moment(now).tz('Europe/Kiev').format('YYYY-MM-DD') +
      'T' +
      Vue.moment(now.getTime() + (startScheduleValue + 5000))
        .tz('Europe/Kiev')
        .format('HH:mm:ss');

  const auctionPeriod = { startDate };
  if (typeAuction === ENGLISH_REVERSE_CONTINUOUS_TYPE || typeAuction === MULTILOT_TYPE) {
    auctionPeriod.plannedEndDate =
      endScheduleValue === SCHEDULE_SPECIFIC
        ? `${auctionEndDateIso}T${auctionEndTime}:00`
        : Vue.moment(startDate)
            .add(Number(endScheduleValue), 'minutes')
            .format('YYYY-MM-DDTHH:mm:ss');
  }
  return auctionPeriod;
}

export function addTypeSpecificPayload(
  dataSend,
  {
    typeAuction,
    minimalStep,
    currency,
    dutchSteps,
    timeOfOneStep,
    antiSnipingEnabled,
    extensionPeriodMinutes,
    reservePriceEnabled,
    reservePrice,
    proxyBiddingEnabled,
  }
) {
  if (typeAuction !== INSIDER_TYPE) {
    dataSend.minimalStep = {
      amount: minimalStep,
      currency,
    };
  }
  if (typeAuction === INSIDER_TYPE) {
    dataSend.auctionParameters = {
      dutchSteps,
      dutchStepDuration: timeOfOneStep * 60,
    };
  } else if (typeAuction === ENGLISH_REVERSE_CONTINUOUS_TYPE) {
    if (antiSnipingEnabled) {
      const minutes = Number(extensionPeriodMinutes);
      const seconds = Math.round((Number.isFinite(minutes) ? minutes : 0) * 60);
      dataSend.antisniping = {
        triggerWindow: seconds,
        extensionPeriod: seconds,
      };
    }
    if (reservePriceEnabled) {
      dataSend.reservePrice = {
        amount: Number(reservePrice),
        currency,
      };
    }
    if (proxyBiddingEnabled) {
      dataSend.proxyBidding = true;
    }
  }
  return dataSend;
}
